/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any -- MobX store requires dynamic typing */

import { getRoot } from 'mobx-state-tree';

import type { IRootModel } from 'watchtower-ui/models/Root';

export const getRootStore = (model: any) => {
  const rootModel: IRootModel = getRoot(model);
  return rootModel;
};
